"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentExtensionStatus = exports.PaymentMethod = exports.AccountBalanceType = void 0;
var AccountBalanceType;
(function (AccountBalanceType) {
    AccountBalanceType["OVERDUE"] = "overdue";
    AccountBalanceType["PAYONTIMEDISCOUNT"] = "payontimediscount";
    AccountBalanceType["CREDIT"] = "credit";
    AccountBalanceType["ZERO"] = "zero";
    AccountBalanceType["BALANCEDUE"] = "balancedue";
})(AccountBalanceType = exports.AccountBalanceType || (exports.AccountBalanceType = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["NONE"] = "none";
    PaymentMethod["DIRECTDEBIT"] = "directdebit";
    PaymentMethod["CREDITCARD"] = "creditcard";
    PaymentMethod["BANK"] = "bank";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var PaymentExtensionStatus;
(function (PaymentExtensionStatus) {
    PaymentExtensionStatus["HASEXISTINGEXTENSION"] = "hasexistingextension";
})(PaymentExtensionStatus = exports.PaymentExtensionStatus || (exports.PaymentExtensionStatus = {}));
//# sourceMappingURL=AccountBalance.types.js.map